import {
    put, all, takeLatest,
} from 'redux-saga/effects';

import {
    SET_COOKIE_PREFERENCES,
    closeModal,
    setCookieTimer,
} from '../reduxModules/ConsentManagementPlatform';

export function* callAction() {
    yield all([
        put(setCookieTimer()),
        put(closeModal()),
    ]);
}

export function* watch() {
    yield takeLatest(SET_COOKIE_PREFERENCES, callAction);
}
